/* Transforme Prénom Nom en initiale */

export const toInitials = (first_name, last_name) => {
    return first_name.substring(0, 1).toUpperCase() + last_name.substring(0, 1).toUpperCase()
}